import script from "./CardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CardItem.vue?vue&type=script&setup=true&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=1c0a4169&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0a4169"]])

export default __exports__